import React, { useState } from "react";
import { Container } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import "../styles/AiotaTermsConditions.css";
import { useNavigate } from "react-router-dom";

const OldMemberTermsConditions = () => {
  const navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleAgreeClick = () => {
    if (isChecked) {
      window.scrollTo(0, 0); // Reset scroll before navigating
      navigate("/old-member-form");
    }
  };
  
  const handleNotNowClick = () => {
    navigate("/");
  };
  
  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <Container className="terms-container py-5">
            <h3 className="text-center mb-4">
              AIOTA Membership Certification – Terms and Conditions for
              Old Members Without Credentials
            </h3>

            <p>
              These Terms and Conditions ("Terms") govern the application
              process for individuals seeking Membership Certification with
              the{" "}
              <strong>
                All India Occupational Therapists' Association (AIOTA)
              </strong>{" "}
              who are old members without credentials. By initiating the application
              process on the AIOTA portal, the applicant agrees to comply with
              the following:
            </p>

            <ol className="terms-list">
              <li>
                <strong>Eligibility Criteria</strong>
                <ul>
                  <li>
                    Be a graduate in Occupational Therapy from a college
                    recognized by the Government of India.
                  </li>
                  <li>
                    Possess valid degree certificate, mark sheets, and
                    internship completion certificate from an accredited
                    institution.
                  </li>
                  <li>
                    Submit all required documents as per AIOTA's document
                    checklist.
                  </li>
                  <li>
                    Agree to abide by the rules and professional ethics of
                    AIOTA.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Application Process</strong>
                <ul>
                  <li>
                    Applications must be submitted only through the official
                    AIOTA portal{" "}
                    <a href="https://aiota.org" target="_blank" rel="noreferrer">
                      https://aiota.org
                    </a>
                    .
                  </li>
                  <li>
                    The applicant must first create an account, log in, and
                    complete the Membership Certification form accurately.
                  </li>
                  <li>
                    All details provided must match the supporting documents
                    submitted.
                  </li>
                  <li>
                    Applicants must{" "}
                    <strong>select their actual college of graduation</strong>{" "}
                    from the dropdown list of AIOTA-accredited colleges.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Mandatory Document Submission</strong>
                <ul>
                  <li>Proof of Identity (Aadhar, PAN, Passport)</li>
                  <li>Passport size photo</li>
                  <li>Old Certificate (if applicable)</li>
                  <li>License Number and IOTR Number</li>
                </ul>
                <p>
                  AIOTA reserves the right to request additional documents or
                  verification if deemed necessary.
                </p>
              </li>

              <li>
                <strong>Fees and Payment</strong>
                <ul>
                  <li>
                    The fee for AIOTA Membership Certification must be paid
                    online through the AIOTA portal.
                  </li>
                  <li>
                    The applicable fee is non-transferable and must be paid only
                    after careful review of eligibility and document readiness.
                  </li>
                  <li>
                    Applicants must ensure all submitted information and
                    documents are accurate before initiating payment.
                  </li>
                </ul>
              </li>

              <li>
                <strong>No Refund Policy</strong>
                <p>
                  AIOTA follows a strict No Refund Policy under all
                  circumstances, including but not limited to:
                </p>
                <ul>
                  <li>
                    If the applicant selects an{" "}
                    <strong>accredited college</strong> from the dropdown list
                    that is not their actual college of graduation, and
                    initiates payment based on this{" "}
                    <strong>knowingly false selection</strong>.
                  </li>
                  <li>
                    If the applicant engages in any form of{" "}
                    <strong>
                      mispractice, fraud, misrepresentation, or unauthorized
                      activity
                    </strong>{" "}
                    to obtain the Membership Certification.
                  </li>
                  <li>
                    If any such activity is{" "}
                    <strong>detected by the AIOTA team</strong>, the application
                    will be cancelled and
                    <strong> no refunds will be issued</strong>.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Verification and Processing</strong>
                <ul>
                  <li>
                    All applications are subject to verification by AIOTA.
                  </li>
                  <li>
                    Processing of membership certification will commence only
                    after full verification and confirmation of the authenticity
                    of submitted documents.
                  </li>
                  <li>
                    Any discrepancy or forged documentation will result in
                    rejection of the application.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Membership Approval</strong>
                <ul>
                  <li>
                    Granting of AIOTA Membership is subject to final
                    approval by the authorized AIOTA verification panel.
                  </li>
                  <li>
                    Once approved, the applicant will receive the official AIOTA
                     Membership Certificate.
                  </li>
                </ul>
              </li>

              <li>
                <strong>Misconduct and Legal Consequences</strong>
                <p>
                  Any individual found guilty of submitting{" "}
                  <strong>fraudulent or false documentation</strong> will be
                  subject to:
                </p>
                <ul>
                  <li>Rejection of the application</li>
                  <li>Permanent blacklisting from AIOTA membership</li>
                  <li>Legal action as per the applicable laws of India</li>
                </ul>
              </li>

              <li>
                <strong>Amendments</strong>
                <p>
                  AIOTA reserves the right to revise, update, or amend these
                  Terms and Conditions at any time without prior notice. It is
                  the responsibility of the applicant to review the latest
                  version available on the website before submitting their
                  application.
                </p>
              </li>

              <li>
                <strong>Contact</strong>
                <p>
                  For queries or clarifications related to the Membership
                  Certification process, please contact:
                  <br />
                  <strong>AIOTA Headquarters</strong>
                  <br />
                  Website: <a href="https://aiota.org">https://aiota.org</a>
                  <br />
                  Email:{" "}
                  <a href="mailto:secretary@aiota.org">secretary@aiota.org</a>
                </p>
              </li>

              <li>
                <strong>Important Note</strong>
                <p style={{ color: "#d32f2f", fontWeight: "bold" }}>
                  If you are an old user without credentials, you need to manually fill details 
                  and requires approvals from the authority for future concerns. Your application 
                  will be reviewed manually by the AIOTA administration team, and approval is 
                  subject to verification of all submitted documents and credentials.
                </p>
              </li>
            </ol>

            <div className="text-left mt-4 d-flex align-items-md-center align-items-start">
              <input
                type="checkbox"
                id="agree"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="agree" className="ms-2">
                I have read, understood, and agreed to all the above Terms and
                Conditions.
              </label>
            </div>

           <div className="text-center mt-3 row justify-content-center gap-2">
  <button 
    className="btn-secondary notrightnow-btn w-auto" 
    onClick={handleNotNowClick}
    >
    Not Right Now
  </button>
  <button
    className="btn-primary"
    onClick={handleAgreeClick}
    disabled={!isChecked}
    style={{ 
      width: "154px", 
      height: "49px",
      position: 'relative',
      opacity: !isChecked ? 0.5 : 1
    }}>
    I Agree
  </button>
</div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default OldMemberTermsConditions;

